export default __webpack_public_path__ + "static/media/bg-gray.b60628d0.svg";